module.exports = __webpack_public_path__ + "media/audio38.6335cc20.mp3";